<template>
  <div>
    <div class="row">
      <div class="col">
        <section class="card card-modern card-big-info">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-2-5 col-xl-1-5">
                <i class="card-big-info-icon bx bx-toggle-right"></i>
                <h2 class="card-big-info-title">Osnovno</h2>
                <p class="card-big-info-desc">Definirajte osnovne parametre.</p>
              </div>
              <div class="col-lg-3-5 col-xl-4-5">
                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Osnovni parametar #01</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <div class="switch switch-success">
                      <toggle-button :width="65" :height="35" color="#47a447" v-model="checked"/>
                    </div>
                    <i
                      class="far fa-question-circle parameter-tooltip"
                      data-bs-toggle="popover"
                      data-bs-container="body"
                      data-bs-placement="right"
                      data-bs-content="Example of right popover, click again to close :)"
                    ></i>
                  </div>
                </div>

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Osnovni parametar #02</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <div class="switch switch-success">
                      <toggle-button :width="65" :height="35" color="#47a447" v-model="checked"/>
                    </div>
                    <i
                      class="far fa-question-circle parameter-tooltip"
                      data-bs-toggle="popover"
                      data-bs-container="body"
                      data-bs-placement="right"
                      data-bs-content="Example of right popover, click again to close :)"
                    ></i>
                  </div>
                </div>

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Osnovni parametar #03</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <div class="switch switch-success">
                      <toggle-button :width="65" :height="35" color="#47a447" v-model="checked"/>
                    </div>
                    <i
                      class="far fa-question-circle parameter-tooltip"
                      data-bs-toggle="popover"
                      data-bs-container="body"
                      data-bs-placement="right"
                      data-bs-content="Example of right popover, click again to close :)"
                    ></i>
                  </div>
                </div>

                <hr />

                <div class="form-group row align-items-center role">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Izaberi jednu opciju</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <select class="form-control populate form-control-modern">
                      <option value="00">Opcija 1</option>
                      <option value="CA">Opcija 2</option>
                      <option value="NV">Opcija 3</option>
                      <option value="OR">Opcija 4</option>
                      <option value="WA">Opcija 5</option>
                    </select>
                  </div>
                </div>

                <div class="form-group row align-items-center role">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Izaberi više opcija</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <select
                      class="form-control"
                      multiple="multiple"
                      data-plugin-multiselect
                      data-plugin-options='{
                        "maxHeight": 200,
                        "includeSelectAllOption": true
                      }'
                      id="ms_example5"
                    >
                      <option value="01">Opcija 1</option>
                      <option value="02">Opcija 2</option>
                      <option value="03">Opcija 3</option>
                      <option value="04">Opcija 4</option>
                      <option value="05">Opcija 5</option>
                      <option value="06">Opcija 6</option>
                      <option value="07">Opcija 7</option>
                      <option value="08">Opcija 8</option>
                      <option value="09">Opcija 9</option>
                    </select>
                  </div>
                </div>

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Unesi tekst npr putanju https://</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <textarea class="form-control" rows="3" id=""></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col">
        <section class="card card-modern card-big-info">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-2-5 col-xl-1-5">
                <i class="card-big-info-icon bx bx-toggle-right"></i>
                <h2 class="card-big-info-title">Napredno</h2>
                <p class="card-big-info-desc">
                  Definirajte napredne parametre.
                </p>
              </div>
              <div class="col-lg-3-5 col-xl-4-5">
                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Osnovni parametar #01</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <div class="checkbox-custom checkbox-primary">
                      <input type="checkbox" checked="" id="checkboxExample2" />
                      <label for="checkboxExample2">Checkbox Primary</label>
                    </div>
                  </div>
                </div>

                <hr />

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Osnovni parametar #02</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <div class="radio-custom radio-primary">
                      <input
                        type="radio"
                        id="radioExample1"
                        name="radioExample"
                      />
                      <label for="radioExample1">Label opcije 1</label>
                    </div>
                    <div class="radio-custom radio-primary">
                      <input
                        type="radio"
                        id="radioExample2"
                        name="radioExample"
                      />
                      <label for="radioExample2">Label opcije 2</label>
                    </div>
                  </div>
                </div>

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Dodatni parametar #04</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <div class="switch switch-success">
                      <toggle-button :width="65" :height="35" color="#47a447" v-model="checked"/>
                    </div>
                    <i
                      data-bs-container="body" data-bs-toggle="popover" data-bs-placement="right" data-bs-content="Example of right popover, click again to close :)"
                      class="far fa-question-circle parameter-tooltip"
                    ></i>
                  </div>
                </div>

                <div class="form-group row align-items-center">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >Input polje</label
                  >
                  <div class="col-lg-7 col-xl-8">
                    <input
                      type="text"
                      class="form-control form-control-modern"
                      name=""
                      value=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <div
      class="action-buttons d-flex justify-content-between"
      style="margin-top: 2rem"
    >
      <div>
        <button
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#delete-modal"
          class="
            delete-button
            btn btn-danger btn-px-4
            py-3
            d-flex
            align-items-center
            font-weight-semibold
            line-height-1
          "
        >
          <i class="bx bx-sync text-4 me-2"></i> Resetiraj
        </button>
      </div>
      <div class="d-flex gap-3">
        <a
          href=""
          class="
            cancel-button
            btn btn-light btn-px-4
            py-3
            border
            font-weight-semibold
            text-color-dark text-3
          "
        >
          Otkaži
        </a>
        <button
          type="submit"
          class="
            submit-button
            btn btn-primary btn-px-4
            py-3
            d-flex
            align-items-center
            font-weight-semibold
            line-height-1
          "
        >
          <i class="bx bx-save text-4 me-2"></i> Sačuvaj
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button';

export default {
  name: 'Settings',
  components: {
    ToggleButton,
  },
  data() {
    return {
      checked: true,
    };
  },
  mounted() {
    $(function () {
      $('[data-bs-toggle="popover"]').popover();
    })
  },
};
</script>
<style lang="scss">
.parameter-tooltip {
  font-size: 16px;
  margin-left: 5px;
  cursor: pointer;
}

.checkbox-component > input + label > .input-box,
.radio-component > input + label > .input-box {
  position: relative;
  border: 1px solid #939393;
  border-radius: 1em;
  width: 1.6em;
  background: #fff;
  transition: background 0.2s ease-in;
  vertical-align: -15%;
}
.checkbox-component > input + label > .input-box > .input-box-tick,
.radio-component > input + label > .input-box > .input-box-circle {
  display: none;
}
.checkbox-component > input + label > .input-box:before,
.radio-component > input + label > .input-box:before {
  content: '';
  position: absolute;
  top: -1px;
  left: -1px;
  border: 1px solid #939393;
  border-radius: 50%;
  width: 1em;
  height: 1em;
  background: #fff;
  transition: transform 0.3s ease-out;
}
.checkbox-component > input:checked + label > .input-box,
.radio-component > input:checked + label > .input-box {
  background: #63b65d;
}
.checkbox-component > input:checked + label > .input-box:before,
.radio-component > input:checked + label > .input-box:before {
  border-color: #498d47;
  transform: translateX(0.6em);
}

</style>